import {
  ChangeEvent,
  MouseEvent,
  FocusEvent,
  ReactNode,
  KeyboardEvent,
} from 'react';
import { SimpleInterpolation } from 'styled-components';

export enum IconPositionInInput {
  left,
  right,
}

export enum BorderRadiusInput {
  left,
  right,
}

export type IInputProps = {
  type: string;
  placeholder?: string;
  error?: string;
  icon?: ReactNode;
  iconPosition?: IconPositionInInput;
  border?: BorderRadiusInput;
  disabled?: boolean;
  defaultValue?: string;
  onClick?: (e?: MouseEvent<HTMLInputElement>) => void;
  readonly?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onChangeDateInput?: (v: Date | null) => void;
  onDateClickOutSide?: () => void;
  setError?: (val?: string) => void;
  maxLength?: number;
  onInput?: (e: ChangeEvent<HTMLInputElement>) => void;
  requiredText?: string;
  name?: string;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onKeyPressCapture?: (e: KeyboardEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  subLabel?: string;
  isDatePickerOpen?: boolean;
  ignoreDateErrors?: boolean;
  value?: string;
  dateInputStart?: string;
  customStyles?: SimpleInterpolation;
  hasCounter?: boolean;
};
